import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid'
import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";
import RepeatOutlinedIcon from '@material-ui/icons/RepeatOutlined';

import Dialog from '../../components/Dialog/Dialog';
import Text from '../../components/Inputs/Text/Text';
import Toast from "../../components/Toast/Toast";

import ButtonsForm, { ButtonSave } from '../../forms/Buttons/ButtonsForm'

import EscolaService from '../../services/Escola';

import {
    isBlank,
    isBlankHelperText,
    isMecCodeInvalid,
    isMecCodeHelperText,
    isMecCodeExistOtherSchool,
    isMecCodeExistHelperText,
    isMecCodeNotValid,
    isUfDiffPrefixMecCodeHelperText,
    isMecCodeExistOtherUser,
    isMecCodeUserExistHelperText,
} from '../../helper/ValidationHelper';

import { mecCodeMask } from '../../helper/MaskHelper';

export class TrocarINEP extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inep: this.props.inep,
            uf: this.props.uf,
            inscrita: this.props.inscrita,
            openDialog: false,
            novoInep: '',
            errors: {
                novoInep: false,
            },
            helpers: {
                novoInep: null,
            },
            loading: false,
        }
    }

    setToast = t => this.Toast = t;

    handleChange = e => {
        this.setState({ 
            ...this.state,           
            [e.target.name]: mecCodeMask(e.target.value),            
            errors: { [e.target.name]: false },
            helpers: { [e.target.name]: false }
        });
    };

    handleOpenDialog = () => {
        this.setState({
            ...this.state,
            openDialog: true,
        })
    }

    handleCloseDialog = (inep = null) => {
        this.setState({
            ...this.state,
            inep: inep ?? this.state.inep,
            openDialog: false,
            novoInep: '',
            errors: {
                novoInep: false,
            },
            helpers: {
                novoInep: null,
            },
            loading: false,
        })
    }

    isValid = async () => {
        const isMesmoInep = this.state.inep === this.state.novoInep;
        const isNovoInepInvalido = isMecCodeInvalid(this.state.novoInep); 

        const escolaComEsseCodigo = this.state.novoInep ? await isMecCodeExistOtherSchool(this.state.novoInep) : null;
        const isNovoInepExiste = escolaComEsseCodigo ? true : false;
        
        const isNovoInepExisteUsuario = this.state.novoInep && !isNovoInepExiste ? await isMecCodeExistOtherUser(this.state.novoInep) === "true" : false;

        const ufPrefixo = this.state.novoInep && !isNovoInepExiste && !isNovoInepExisteUsuario ? await isMecCodeNotValid(this.state.novoInep) : null;
        const isNovoInepUfIncorreta = ufPrefixo ? this.state.uf !== ufPrefixo.cdUf : false;

        if (isBlank(this.state.novoInep) || isMesmoInep || isNovoInepInvalido || isNovoInepExiste || isNovoInepExisteUsuario || isNovoInepUfIncorreta) { 
            this.setState({
                errors: {
                    novoInep: isBlank(this.state.novoInep) || isMesmoInep || isNovoInepInvalido || isNovoInepExiste || isNovoInepExisteUsuario || isNovoInepUfIncorreta ? true : false,
                },
                helpers: {
                    novoInep: isBlank(this.state.novoInep) ? isBlankHelperText() : 
                                isMesmoInep ? "O INEP deve ser Diferente do Atual" :
                                isNovoInepInvalido ? isMecCodeHelperText() : 
                                isNovoInepExiste ? isMecCodeExistHelperText(escolaComEsseCodigo.nmEscola) :
                                isNovoInepExisteUsuario ? isMecCodeUserExistHelperText() :
                                isNovoInepUfIncorreta ? isUfDiffPrefixMecCodeHelperText() : null, 
                }
            })

            return false;
        }

        return true;
    }

    handleSubmit = async () => {
        this.setState({ loading: true });

        const formIsValid = await this.isValid();

        if (!formIsValid) {
            this.setState({ loading: false });
            return
        }

        EscolaService.trocarInep(this.state.inep, this.state.novoInep)
            .then(() => {
                this.Toast.setState({
                    message: {
                        message: "Troca de INEP da Escola Realizada com Sucesso.",
                        type: 'success',
                        open: true
                    }
                });
                
                this.reload();                
                this.handleCloseDialog(this.state.novoInep);
            })
            .catch(() => {
                this.Toast.setState({
                    message: {
                        message: "Não Foi Possível Realizar a Troca do INEP da Escola.",
                        type: 'error',
                        open: true
                    }
                })

            })
            .finally(() => this.setState({ loading: false }));
    }

    buttons = () => {
        return (
            <ButtonsForm
                onClick={this.handleSubmit}
                onBack={() => this.handleCloseDialog()}
                loading={this.state.loading}
            />
        )
    }

    reload = () => {
        this.props.history.push(`/admin/escola/${this.state.novoInep}/editar`);
        this.props.handleChange(this.state.novoInep);
    }

    render() {
        return (
            <>  
                <Toast parentRef={this.setToast} />
                <ButtonSave
                    name="Trocar INEP"
                    startIcon={<RepeatOutlinedIcon />}
                    onClick={this.handleOpenDialog}
                />
                
                <Dialog
                    maxWidth={"md"}
                    fullWidth={true}
                    closeDialog={() => this.handleCloseDialog()}
                    openDialog={this.state.openDialog}
                    title={`Trocar INEP da Escola`}
                    actions={this.buttons()}
                >
                    <Grid container spacing={3}>
                        <Grid item sm={12} lg={12}>
                            <Alert severity="warning">
                                <Typography variant="overline"><b>ATENÇÃO</b></Typography>
                                <Typography variant="body2">
                                    As ações que deverão ser analisadas antes da Troca de INEP da Escola estão listadas abaixo, e após realizada, a troca <b>NÃO</b> poderá ser desfeita. 

                                    <ul style={{ paddingTop: '12px', paddingLeft: '20px' }}>
                                        <li style={{ marginBottom: '4px' }}>
                                            A Troca de INEP, <b>NÃO</b> realiza trocas de acessos e nem de dados de inscrições das <b>Edições Anteriores</b>. 
                                        </li>
                                        <li style={{ marginBottom: '4px' }}> 
                                            Caso a Escola tenha uma inscrição em alguma outra edição, seu acesso ao sistema será mantido como o INEP <b>({this.state.inep})</b> e senha utilizados nas demais edições.
                                        </li>
                                        <li style={{ marginBottom: '4px' }}> 
                                            Se em alguma outra edição, o INEP sugerido como novo já tenha sido utilizado por outra escola, a troca <b>NÃO SERÁ PERMITIDA</b> via sistema.
                                        </li>
                                        
                                        { this.state.inscrita &&
                                            <>
                                                <li style={{ marginBottom: '4px' }}>
                                                    A inscrição e os dados da Escola <b>NÃO</b> sofrerão nenhuma alteração, além da atribuição de novo vínculo ao <b>Novo Código INEP</b> informado.
                                                </li>
                                                <li style={{ marginBottom: '4px' }}> 
                                                    A Escola deverá <b>Recuperar a Senha</b> utilizando o Novo Código INEP para ter Acesso ao Sistema na Edição Atual.
                                                </li>
                                            </>
                                        }
                                    </ul>
                                </Typography>
                            </Alert>
                        </Grid>

                        <Grid item sm={12} lg={12}>
                            <Text
                                required
                                name="novoInep"
                                label="Novo Código INEP"
                                value={this.state.novoInep}
                                onChange={this.handleChange}
                                error={this.state.errors.novoInep}
                                helperText={this.state.helpers.novoInep}
                            />
                        </Grid>                    
                    </Grid>
                </Dialog>
            </>
        )
    }
};

export default withRouter(TrocarINEP);